/**
 * Caption typography above inputs — shared by TextField, TextareaField, Select.
 */
export type FieldCaptionSize = 'sm' | 'md'

export const FIELD_CAPTION_TEXT_CLASS: Record<FieldCaptionSize, string> = {
  sm: 'text-[12px] leading-[20px] tracking-[-0.18px]',
  md: 'text-[14px] leading-[20px] tracking-[-0.21px]',
} as const
